import { useTranslation } from "react-i18next";
import { FormikInsurance, FormikContractorNatural } from "src/types";

export const useNaturalContractorSummary = ({
  insurance,
}: {
  insurance: FormikInsurance;
}) => {
  const { t } = useTranslation();

  const naturalContractor = insurance.contractor as FormikContractorNatural;

  return { naturalContractor, t };
};
